import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryvanrentalswithdriverinmumbai() {



  const cardData =
  {
    keyword: 'Luxury Van Rentals with Drivers in Mumbai',
    heading: 'Aaryan Travels: Luxury Van Rentals with Drivers in Mumbai',
    headingDescription: 'Aaryan Travels offers premium Luxury Van Rentals with Drivers in Mumbai for group travel, VIP transportation, weddings, and corporate movement. Whether you need a high-end van for family trips, celebrity logistics, airport transfers from Chhatrapati Shivaji Maharaj International Airport, or executive shuttles for business events, our fleet—including luxury Tempo Travellers, Urbania vans, and premium minivans—ensures maximum comfort and style. With plush seating, AC interiors, professional chauffeurs, and optional amenities like Wi-Fi and refreshments, Aaryan Travels delivers a smooth and elegant travel experience across South Mumbai, Bandra, Andheri, Navi Mumbai, and Thane.',

    top: 'Top Places to Visit in Mumbai with Aaryan Travels',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924 overlooking the Arabian Sea, is Mumbai’s most iconic landmark. Originally constructed to commemorate the visit of King George V and Queen Mary, it now serves as a major tourist hub. Visitors enjoy ferry rides to Elephanta Caves while soaking in sea views. Illuminated beautifully at night, it offers a majestic sight by the waterfront. Gateway of India is Mumbai’s timeless emblem of pride and grandeur."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace due to its glowing arc of streetlights at night, is Mumbai’s favorite promenade. Locals gather here for evening walks, sea breeze, and sunset views. Street foods like bhel puri and roasted peanuts add to the charm. Early mornings and late nights both have their unique appeal. Marine Drive is Mumbai’s soothing stretch of serenity amidst chaos."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, CST is a stunning example of Victorian Gothic architecture built in 1887. Its domes, spires, and stained glass windows make it resemble a royal palace. Despite being a functional railway station, it remains one of the busiest in India. The illuminated structure at night is a breathtaking view. CST is Mumbai’s architectural jewel of history and motion."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most lively seaside destinations, known for its golden sands and vibrant street food culture. Visitors relish mouth-watering pav bhaji, pani puri, and ice gola while enjoying the sea breeze. The area is also home to several Bollywood celebrities. Sunsets here are especially charming and photogenic. Juhu Beach is Mumbai’s joyful coastal escape."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a 15th-century mosque and tomb located on an islet connected by a narrow causeway. During high tide, it appears to be floating in the sea. Devotees of all faiths visit to seek blessings and listen to soulful qawwalis. The white marble structure radiates peace and unity. Haji Ali is Mumbai’s spiritual island of devotion."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are ancient rock-cut caves from the 5th century dedicated to Lord Shiva. The giant Trimurti sculpture of Shiva is the centerpiece, depicting creation, protection, and destruction. A ferry ride from Gateway of India adds adventure to the visit. Surrounded by greenery and ancient art, it offers a journey into history. Elephanta Caves are Mumbai’s timeless heritage carved in stone."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered temples dedicated to Lord Ganesha. Devotees, including film stars and politicians, visit to seek blessings and prosperity. The idol is adorned beautifully with gold and fresh flowers. Tuesdays witness long queues of worshippers. Siddhivinayak is Mumbai’s divine center of faith and gratitude."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel and one of Mumbai’s most scenic drive routes. The cable-stayed bridge stretches gracefully over the Arabian Sea, reducing travel time between the suburbs and South Mumbai. At night, the illuminated bridge looks futuristic and grand. The sea view while driving across is unforgettable. The Sea Link is Mumbai’s shining symbol of progress and power."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a vibrant street market known for fashion accessories, handicrafts, and antiques. Bargain shoppers love exploring its endless stalls. Legendary cafes like Leopold Cafe and Café Mondegar add colonial charm. The street buzzes with artists, tourists, and vendors all day long. Colaba Causeway is Mumbai’s colorful paradise of shopping and culture."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is one of the world’s largest urban forests, offering jeep safaris, trekking trails, and boating experiences. Wildlife such as deer, monkeys, and leopards can be spotted within its dense greenery. The ancient Kanheri Caves inside the park add historic charm. It is a perfect weekend escape from city life. SGNP is Mumbai’s wild retreat into nature."
  }
],



"services": [
  {
    "name": "Luxury Van Rentals with Drivers in Mumbai",
    "description": "Luxury Van Rentals with Drivers in Mumbai offer spacious, comfortable, and premium vans driven by professional chauffeurs. Perfect for corporate groups, families, and special events, this service ensures a smooth, stylish, and reliable travel experience with ample space and luxury amenities."
  },
  {
    "name": "Chauffeur Driven Van Mumbai",
    "description": "Chauffeur Driven Van Mumbai provides expert-driven vans for clients who prioritize safety, comfort, and punctuality. Ideal for business outings, airport transfers, and group travel, these services come with courteous drivers trained to offer a seamless travel experience."
  },
  {
    "name": "Premium Van Hire Mumbai",
    "description": "Premium Van Hire Mumbai caters to those seeking high-quality vehicles with modern features and elegant interiors. This service focuses on delivering a first-class travel experience for corporate events, family outings, and long-distance journeys."
  },
  {
    "name": "Executive Van Rental Mumbai",
    "description": "Executive Van Rental Mumbai specializes in providing luxury vans equipped with advanced amenities and professional chauffeurs. Designed for business professionals and VIP groups, this service ensures privacy, comfort, and efficient transportation."
  },
  {
    "name": "Corporate Van Services Mumbai",
    "description": "Corporate Van Services Mumbai offer dependable and flexible van rental solutions tailored to meet the needs of companies. Whether for daily staff transportation or client visits, this service combines professionalism with affordability."
  },
  {
    "name": "Wedding Van Rentals Mumbai",
    "description": "Wedding Van Rentals Mumbai provide elegant and spacious vans for wedding parties and guest transport. Chauffeurs trained in event etiquette ensure timely pickups and a grand, comfortable ride on special occasions."
  },
  {
    "name": "Family Van Hire Mumbai",
    "description": "Family Van Hire Mumbai offers large, comfortable vans perfect for family trips, outings, and vacations. Safety features, ample luggage space, and courteous drivers make this an ideal choice for hassle-free group travel."
  },
  {
    "name": "Affordable Luxury Van Mumbai",
    "description": "Affordable Luxury Van Mumbai combines high standards of comfort and service with competitive pricing, making luxury van travel accessible for budget-conscious clients without compromising on quality or professionalism."
  },
  {
    "name": "Online Van Booking Mumbai",
    "description": "Online Van Booking Mumbai provides an easy-to-use digital platform for reserving luxury vans with drivers. With instant confirmations, transparent pricing, and real-time updates, this service streamlines the booking process for clients."
  },
  {
    "name": "Van with Driver Mumbai",
    "description": "Van with Driver Mumbai ensures a seamless travel experience by pairing clients with professional drivers who are knowledgeable about Mumbai's routes and traffic patterns, guaranteeing timely and stress-free transportation."
  },
  {
    "name": "Multi-Seater Luxury Van Mumbai",
    "description": "Multi-Seater Luxury Van Mumbai offers vans that comfortably accommodate large groups, featuring premium interiors and entertainment options. Perfect for corporate outings, family vacations, and event transport, these vans deliver both luxury and practicality."
  },
  {
    "name": "High-End Van Rental Mumbai",
    "description": "High-End Van Rental Mumbai provides elite vans with luxurious finishes and state-of-the-art features, driven by professional chauffeurs who ensure a dignified and relaxing ride for all occasions."
  },
  {
    "name": "Event Transport Van Mumbai",
    "description": "Event Transport Van Mumbai specializes in providing reliable and stylish transportation for corporate events, weddings, and large gatherings. The service includes flexible scheduling and professional chauffeur support to meet specific event needs."
  },
  {
    "name": "Mumbai Van Hire Services",
    "description": "Mumbai Van Hire Services offers a broad selection of luxury vans with expert drivers to accommodate various travel requirements, including business trips, family travel, and special events, emphasizing safety and customer satisfaction."
  },
  {
    "name": "Prestige Van Rentals Mumbai",
    "description": "Prestige Van Rentals Mumbai delivers premium vans with exquisite interiors and courteous chauffeurs, tailored for clients who demand excellence and comfort for group travel in Mumbai."
  }
],
"tableData": [
  ["Luxury Van Rentals with Drivers in Mumbai", "Chauffeur Driven Van Mumbai"],
  ["Premium Van Hire Mumbai", "Executive Van Rental Mumbai"],
  ["Corporate Van Services Mumbai", "Wedding Van Rentals Mumbai"],
  ["Family Van Hire Mumbai", "Affordable Luxury Van Mumbai"],
  ["Online Van Booking Mumbai", "Van with Driver Mumbai"],
  ["Multi-Seater Luxury Van Mumbai", "High-End Van Rental Mumbai"],
  ["Event Transport Van Mumbai", "Mumbai Van Hire Services"],
  ["Prestige Van Rentals Mumbai", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Van Rentals with Drivers in Mumbai",
    "WhyChoosedescription": "Aaryan Travels offers spacious and comfortable luxury van rentals with professional drivers in Mumbai, perfect for group travel and corporate events."
  },
  {
    "WhyChooseheading": "Fleet of Premium Luxury Vans",
    "WhyChoosedescription": "Choose from our well-maintained luxury vans that combine style, space, and comfort for your journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our courteous drivers ensure punctual, safe, and reliable service tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
    "WhyChoosedescription": "All vans are regularly cleaned and maintained to guarantee hygiene and passenger comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Benefit from all-inclusive pricing covering fuel, tolls, and driver allowances without any surprise fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose hourly, daily, or customized rental options to suit your group’s luxury travel requirements."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service Across Mumbai",
    "WhyChoosedescription": "We ensure timely pickups and drop-offs anywhere in Mumbai for a smooth and comfortable travel experience."
  }
]


















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer luxury van rentals with drivers in Mumbai?',
    answer: 'Yes, Aaryan Travels provides premium luxury van rentals with professional drivers in Mumbai for comfortable group travel.',
  },
  {
    question: 'How can I book luxury van rentals with drivers in Mumbai?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Mumbai.',
  },
  {
    question: 'What types of luxury vans are available for rental with drivers in Mumbai?',
    answer: 'Aaryan Travels offers a range of luxury vans including Mercedes V-Class, Toyota Innova Crysta, and other premium vehicles with drivers.',
  },
  {
    question: 'Are the drivers experienced and trained for luxury van rentals in Mumbai?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and committed to providing a premium travel experience.',
  },
  {
    question: 'Can luxury van rentals with drivers be booked for corporate and personal use in Mumbai?',
    answer: 'Yes, these rentals are ideal for corporate travel, airport transfers, weddings, and group outings in Mumbai.',
  },
  {
    question: 'Is the luxury van rental service with drivers available 24x7 in Mumbai?',
    answer: 'Yes, Aaryan Travels offers round-the-clock luxury van rental services with drivers to suit your schedule in Mumbai.',
  },
  {
    question: 'Are hygiene and safety protocols followed for luxury van rentals?',
    answer: 'All vehicles are sanitized thoroughly, and drivers adhere to strict safety and hygiene standards for your comfort and safety.',
  },
  {
    question: 'What payment options are accepted for luxury van rentals with drivers in Mumbai?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the luxury van rental period in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Mehta',
    feedback: 'Aaryan Travels provided excellent luxury van rentals with professional drivers in Mumbai. Perfect for our corporate outing.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Nair',
    feedback: 'Highly recommend Aaryan Travels for luxury van rentals with drivers in Mumbai. Great service and comfortable vehicles.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];










const luxuryVanRentalsMumbaiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Luxury Van Rentals with Drivers in Mumbai",
  "description": "Aaryan Travels offers chauffeur-driven luxury van rentals in Mumbai, including premium van hire, executive van rentals, corporate and wedding van services, family van hire, and more.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  },
  "serviceType": "Luxury Van Rental Service",
  "keywords": "Luxury Van Rentals with Drivers in Mumbai, Chauffeur Driven Van Mumbai, Premium Van Hire Mumbai, Executive Van Rental Mumbai, Corporate Van Services Mumbai, Wedding Van Rentals Mumbai, Family Van Hire Mumbai, Affordable Luxury Van Mumbai, Online Van Booking Mumbai, Van with Driver Mumbai, Multi-Seater Luxury Van Mumbai, High-End Van Rental Mumbai, Event Transport Van Mumbai, Mumbai Van Hire Services, Prestige Van Rentals Mumbai"
};





  return (
    <div>

<Helmet>
  <title>Luxury Van Rentals with Drivers in Mumbai | Chauffeur Driven Executive Vans | Aaryan Travels</title>
  <meta
    name="description"
    content="Book luxury van rentals with drivers in Mumbai at Aaryan Travels. Chauffeur-driven executive vans, premium multi-seater vans, corporate, wedding, and family van hire services."
  />
  <meta
    name="keywords"
    content="Luxury Van Rentals with Drivers in Mumbai, Chauffeur Driven Van Mumbai, Premium Van Hire Mumbai, Executive Van Rental Mumbai, Corporate Van Services Mumbai, Wedding Van Rentals Mumbai, Family Van Hire Mumbai, Affordable Luxury Van Mumbai, Online Van Booking Mumbai, Van with Driver Mumbai, Multi-Seater Luxury Van Mumbai, High-End Van Rental Mumbai, Event Transport Van Mumbai, Mumbai Van Hire Services, Prestige Van Rentals Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(luxuryVanRentalsMumbaiSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxuryvanrentalswithdriverinmumbai;